import React, {Component} from 'react';
import { NavLink,Link } from 'react-router-dom';
import WineIcon from '../../../assets/images/icons/wine-icon-wt-bg.png';
import ProductDefaultImage from '../../../assets/images/product-default-image.jpg'
import ProductCard from "../cards/ProductCard";
const FeaturedList = ({title, icon, viewAllLinkProps,products, onSelectProduct,onProductAddToCart,onCheckAvailiblityAlert}) => {

  return (
    <React.Fragment>
    {renderNew()}</React.Fragment>
  )
  function renderNew() {
    return (<div className="col-md-12 product-cards pl-0 pr-0">

      {renderHeader()}
          {products.map(product => {
            return (
              <div
                className="col-md-2 col-sm-2 product-card-container"
                key={product._id}
              >
                <ProductCard
                  data={product}
                  onSelectProduct={() => onSelectProduct(product)}
                  onAddToCart={() => onProductAddToCart(product)}
                  checkAvailiblityAlert={() => onCheckAvailiblityAlert()}
                  noOutOfStock={true}
                />
              </div>
            );
          })}
        </div>)
    
  }

  function renderHeader() {
    const linkProps = viewAllLinkProps ? viewAllLinkProps : {to: "/products"}
    return (
      <div className="row col-md-12 pr-0 mr-0">
                      <div className="col-md-6 "><NavLink {...linkProps} className="title-link"><h2 className='row-title'><img src={icon ? icon : null} height={50} className="pr-2" alt={title}/>{title ? title : ''}</h2></NavLink></div>
                      <div className="col-md-6 pr-0 align-self-center"><span className="float-right "><NavLink {...linkProps}>{`VIEW ALL  ${title ? title : 'items'}`}</NavLink></span></div></div>
    )
  }
  
}

export default FeaturedList;



// WEBPACK FOOTER //
// ./src/components/commons/lists/FeaturedList.js